import { Text, Tooltip } from '@shared/components';
import {
  formatChatDayDetail,
  formatChatDayLabel,
} from '../utils/chatTimestamps';

export function ChatDayLabel({
  date,
  hasPrecedingItems = false,
}: {
  date: Date;
  hasPrecedingItems?: boolean;
}) {
  return (
    <div
      className={
        hasPrecedingItems
          ? 'sticky top-0 z-10 -ml-16 mb-3 mt-4 w-16 self-start bg-white py-1'
          : 'sticky top-0 z-10 -ml-16 mb-3 w-16 self-start bg-white py-1'
      }
    >
      <Tooltip content={formatChatDayDetail(date)}>
        <Text type="body-xs" as="h3" className="text-gray-400">
          {formatChatDayLabel(date)}
        </Text>
      </Tooltip>
    </div>
  );
}
